import { useLingui } from '@lingui/react';

import { TSupportedLocales } from '../types';
import { DE_LOCALE, UK_LOCALE } from '../utils/i18n';

export function useLocale() {
  const { i18n } = useLingui();
  const locale = i18n.locale as TSupportedLocales;

  const isDE = locale === DE_LOCALE;
  const isUK = locale === UK_LOCALE;

  return {
    isDE,
    isUK,
    i18n,
    locale,
  };
}
